export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

  const row = [];
  for (let i = strNumber.length; i > 0; i -= 3) {
    row.push(strNumber.substring(Math.max(i - 3, 0), i));
  }

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    const chuc = Math.floor(so / 10);
    const donvi = so % 10;
    if (chuc > 1) {
      chuoi = " " + chuSo[chuc] + " mươi";
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) {
      chuoi = " linh";
    }
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += " " + chuSo[donvi];
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    const tram = Math.floor(so / 100);
    const soDu = so % 100;
    if (daydu || tram > 0) {
      return ` ${chuSo[tram]} trăm${docHangChuc(soDu, true)}`;
    }
    return docHangChuc(soDu, false);
  };

  let ketQua = "";
  const viTri = row.length - 1;
  for (let i = viTri; i >= 0; i -= 1) {
    const soNhom = parseInt(row[i], 10);
    if (soNhom > 0) {
      ketQua += `${docKhoi(soNhom, i !== viTri)} ${tien[i]}`;
    }
  }

  const normalized = ketQua.trim();
  return `${normalized.charAt(0).toUpperCase() + normalized.slice(1)} đồng chẵn`;
};

const parseMoney = (value) => Number(String(value || "").replace(/\D/g, "")) || 0;
const fmt = (n) => new Intl.NumberFormat("vi-VN").format(Math.round(parseMoney(n)));

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const workStartDate = headerInfo.workStartDate || ".../.../....";
  const workEndDate = headerInfo.workEndDate || ".../.../....";

  const rowsHtml = rows
    .map(
      (row, i) => `
      <tr>
        <td class="text-center">${i + 1}</td>
        <td class="text-left">${row.fullName || ""}</td>
        <td class="text-center">${row.identityNumber || ""}</td>
        <td class="text-left">${row.jobName || ""}</td>
        <td class="text-right">${row.workQuantity || ""}</td>
        <td class="text-right">${row.unitPrice ? fmt(row.unitPrice) : ""}</td>
        <td class="text-right">${fmt(row.grossAmount)}</td>
        <td class="text-right">${fmt(row.taxWithheld)}</td>
        <td class="text-right">${fmt(row.netAmount)}</td>
        <td class="text-center">${row.signature || ""}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Bảng Thanh Toán Tiền Thuê Ngoài</title>
      <style>
        @media print { @page { margin: 10mm; size: landscape; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 12px; color: #000; padding: 20px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #000; padding: 4px; }
        th { text-align: center; font-weight: bold; vertical-align: middle; }
        .text-left { text-align: left; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div style="display:flex;justify-content:space-between">
        <div>
          <div><b>Đơn vị:</b> ${headerInfo.unit || ""}</div>
          <div><b>Bộ phận:</b> ${headerInfo.department || ""}</div>
        </div>
        <div style="text-align:center">
          <div><b>Mẫu số: 04 - LĐTL</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <h2 style="text-align:center;margin:10px 0 0">BẢNG THANH TOÁN TIỀN THUÊ NGOÀI</h2>
      <div style="text-align:center;font-weight:bold;margin-top:3px">(Dùng cho thuê nhân công, thuê khoán việc)</div>

      <div style="display:flex;justify-content:space-between;margin-top:10px;">
        <div>Họ và tên người thuê: ${headerInfo.hirerName || ""}</div>
        <div>Số: ${headerInfo.docNumber || ""}</div>
      </div>

      <div style="margin-top:8px">Bộ phận (hoặc địa chỉ): ${headerInfo.hirerDepartmentAddress || ""}</div>

      <div style="margin-top:8px">
        Đã thuê những công việc sau để: ${headerInfo.workPurpose || ""}
        tại địa điểm ${headerInfo.workLocation || ""}
        từ ngày ${workStartDate}
        đến ngày ${workEndDate}
      </div>

      <table style="margin-top:10px">
        <thead>
          <tr>
            <th>STT</th>
            <th>Họ và tên người được thuê</th>
            <th>CCCD/MST TNCN của người được thuê</th>
            <th>Nội dung hoặc tên công việc thuê</th>
            <th>Số công hoặc khối lượng công việc đã làm</th>
            <th>Đơn giá thanh toán</th>
            <th>Thành tiền</th>
            <th>Tiền thuế khấu trừ</th>
            <th>Số tiền còn lại được nhận</th>
            <th>Ký nhận</th>
          </tr>
          <tr style="background:#fafafa">
            <th>A</th><th>B</th><th>C</th><th>D</th><th>1</th><th>2</th><th>3</th><th>4</th><th>5 = 3-4</th><th>E</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td></td>
            <td class="text-center"><b>Cộng</b></td>
            <td class="text-center">x</td>
            <td class="text-center">x</td>
            <td class="text-center">x</td>
            <td class="text-center">x</td>
            <td class="text-right"><b>${fmt(totals.totalBeforeTax)}</b></td>
            <td class="text-right"><b>${fmt(totals.totalTaxWithheld)}</b></td>
            <td class="text-right"><b>${fmt(totals.totalNetPayment)}</b></td>
            <td class="text-center">x</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top:10px">Đề nghị ${headerInfo.requestTo || "............."} cho thanh toán số tiền:</div>
      <div style="margin-top:6px">Số tiền (Viết bằng chữ): <b>${numberToWords(totals.totalNetPayment)}</b></div>
      <div style="margin-top:6px"><i>(Kèm theo ${headerInfo.attachmentNote || "..."} chứng từ kế toán khác)</i></div>

      <div style="display:flex;justify-content:space-between;margin-top:20px;text-align:center">
        <div><b>Người đề nghị thanh toán</b><br/><i>(Ký, họ tên)</i></div>
        <div><b>Kế toán trưởng</b><br/><i>(Ký, họ tên)</i></div>
        <div><i>Ngày....tháng....năm....</i><br/><b>Người duyệt</b><br/><i>(Ký, họ tên)</i></div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
